
{
  "title": "Subscription plans for Hong Kong service providers",
  "subtitle": "Start with one listing, then upgrade when you need verification, analytics, more areas, or more listings.",
  "buttons": {
    "signUp": "Sign Up",
    "currentPlan": "Current Plan",
    "purchase": "Subscribe",
    "notAvailable": "Not Available"
  },
  "comparison": {
    "headers": {
      "features": "Compare plans"
    },
    "badges": {
      "whatsapp": "Verification",
      "premium": "Growth"
    },
    "features": {
      "listings": "Service listings",
      "categories": "Categories",
      "areas": "Service areas",
      "profile": "Provider profile",
      "verifiedBadge": "Verified badge",
      "analytics": "Listing analytics",
      "priority": "Priority placement"
    },
    "values": {
      "allServiceAreas": "All service areas"
    },
    "included": "Included",
    "notIncluded": "Not included"
  },
  "pricingTable": {
    "free": {
      "title": "Starter",
      "price": "HK$0",
      "period": "forever",
      "description": "One listing to test demand before subscribing",
      "features": {
        "maxListings": "1 service listing",
        "singleCategory": "Single category per listing",
        "maxAreas": "Up to 2 service areas",
        "basicProfile": "Basic profile features"
      }
    },
    "whatsapp": {
      "title": "WhatsApp Verified",
      "price": "HK$100",
      "period": "annually",
      "description": "Add verification and basic performance insight",
      "features": {
        "maxListings": "1 service listing",
        "singleCategory": "Single category per listing",
        "maxAreas": "Up to 4 service areas",
        "basicProfile": "Basic profile features",
        "verifiedBadge": "WhatsApp verified badge",
        "listingAnalytics": "Listing analytics"
      }
    },
    "premium": {
      "title": "Premium",
      "price": "HK$500",
      "period": "annually",
      "description": "Scale your provider presence across the directory",
      "features": {
        "unlimitedListings": "Unlimited service listings",
        "multipleCategories": "Multiple categories per listing",
        "enhancedProfile": "Enhanced profile features",
        "verifiedBadge": "WhatsApp verified badge",
        "priorityPlacement": "Priority placement in search",
        "listingAnalytics": "Listing analytics"
      }
    }
  },
  "faq": {
    "title": "Frequently Asked Questions",
    "howToStart": "How do I get started?",
    "howToStartAnswer": "Sign up to browse services or create your first provider listing. You can start on the Starter plan and upgrade when you need more capability.",
    "howToStartAnswerLoggedIn": "You're already signed up. You can create a listing, manage your subscription, or upgrade when you need more provider features.",
    "howToUpgrade": "How do I upgrade my plan?",
    "howToUpgradeAnswer": "You can upgrade from your account subscription tab or choose a paid plan on this page.",
    "howToUpgradeAnswerGuest": "Create an account first, then choose the plan that fits your listing needs.",
    "canCancel": "Can I cancel anytime?",
    "canCancelAnswer": "Paid subscriptions are managed through Stripe. You can use the customer portal to manage billing, and you can delete your account if you want your associated account data removed.",
    "paymentMethods": "What payment methods do you accept?",
    "paymentMethodsAnswer": "Stripe Checkout shows the supported payment methods directly during checkout based on your location and Stripe availability.",
    "tierDifference": "What's the difference between tiers?",
    "tierDifferenceAnswer": "Starter is for one basic listing. WhatsApp Verified adds verification and analytics for one listing. Premium is for providers who need unlimited listings, broader category coverage, priority placement, and analytics."
  }
}
